<template>
    <div class="position-relative">
        <v-overlay-loader :loading="detailLoading" text="Detay yükleniyor"/>
        <b-card>
            <b-modal id="update-inflation" title="Enflasyon Oranı Güncelle" no-close-on-esc no-close-on-backdrop>
                <update-inflation v-model="InflationData"></update-inflation>
                <template #modal-footer><v-executer :action="updateInflation"></v-executer></template>
            </b-modal>
            <!-- Cari yalnızca boşken bağlanır; dolu cariyi değiştirme sunucuda reddedilir. -->
            <b-modal id="update-cari" title="Cari Seç" no-close-on-esc no-close-on-backdrop>
                <label class="form-label">Cari <span class="text-danger">*</span></label>
                <v-select-list
                    :loading="cariLoading"
                    :options="cariList"
                    v-on:search="getCariList"
                    v-model="cari"
                    placeholder="Aramak için yazınız"
                    label="CARI_ISIM"></v-select-list>
                <small class="text-muted d-block mt-50">
                    Cari bir kez bağlandıktan sonra bu ekrandan değiştirilemez.
                </small>
                <template #modal-footer>
                    <v-executer text="Kaydet" :disabled="!canUpdateCari" :action="updateCari" :loading="cariUpdating"></v-executer>
                </template>
            </b-modal>
            <b-modal id="update-price" title="Rota Fiyat Güncelle" no-close-on-esc no-close-on-backdrop>
                <update-route-price v-model="currentRoutePrice"></update-route-price>
                <template #modal-footer><v-executer :loading="priceUpdating" :action="updatePrice" text="Güncelle" :disabled="!canUpdatePrice"></v-executer></template>
            </b-modal>
            <b-modal id="add-route" title="Yeni Rota" no-close-on-esc no-close-on-backdrop>
                <add-route v-model="route" v-on:validation="routeValidationMessage = $event"></add-route>
                <template #modal-footer><v-executer :disabled="hasEmpty" :action="addRoute" :loading="routeAdding"></v-executer></template>
            </b-modal>
            <b-modal id="bulk-add-routes" title="Excel ile Toplu Rota Ekle" size="xl" no-close-on-esc no-close-on-backdrop>
                <bulk-add-routes ref="bulkAddRoutes" :agreement-id="$route.params.id" v-on:ready="bulkAddReady = $event"></bulk-add-routes>
                <template #modal-footer>
                    <v-executer
                        text="Rotaları Kaydet"
                        :disabled="!bulkAddReady"
                        :action="saveBulkRoutes"
                        :loading="bulkAdding"></v-executer>
                </template>
            </b-modal>
            <b-modal id="bulk-delete-routes" title="Seçilen Rotaları Sil" no-close-on-esc no-close-on-backdrop>
                <div class="row">
                    <div class="col-12 mb-1">
                        <b-alert show variant="warning" class="p-1 mb-0">
                            <b>{{ selectedRouteIds.length }}</b> rota silinecek. Bu işlem geri alınamaz.
                        </b-alert>
                    </div>
                    <div class="col-12">
                        <label class="form-label">Silme Kapsamı</label>
                        <b-form-radio-group v-model="deleteIncludeHistory" stacked>
                            <b-form-radio :value="true">
                                Tüm fiyat geçmişiyle birlikte sil
                                <small class="d-block text-muted">
                                    Rotanın geçmiş fiyat versiyonları da kaldırılır. Rotaları yeniden
                                    ekleyecekseniz bunu seçin; aksi halde eski versiyonlar kalır ve yeni
                                    fiyat zinciriyle çakışır. <b>Silinen tarihlerden önceki seferler bu
                                    rotadan fiyat bulamaz.</b>
                                </small>
                            </b-form-radio>
                            <b-form-radio :value="false">
                                Yalnızca güncel fiyatı sil
                                <small class="d-block text-muted">
                                    Rota listeden kalkar ama geçmiş fiyat kaydı korunur; geçmiş seferler
                                    fiyatlanmaya devam eder. Rotayı yeniden ekleyecekseniz önerilmez.
                                </small>
                            </b-form-radio>
                        </b-form-radio-group>
                    </div>
                </div>
                <template #modal-footer>
                    <v-executer
                        variant="danger"
                        text="Sil"
                        :action="deleteSelectedRoutes"
                        :loading="bulkDeleting"></v-executer>
                </template>
            </b-modal>
            <b-modal id="bulk-update-prices" title="Toplu Fiyat Düzenle" size="xl" no-close-on-esc no-close-on-backdrop>
                <bulk-update-prices ref="bulkUpdatePrices" :route-prices="Agreement.AgreementRoutePrices" :agreement-id="$route.params.id" v-on:ready="bulkUpdateReady = $event"></bulk-update-prices>
                <template #modal-footer>
                    <v-executer
                        text="Fiyatları Güncelle"
                        :disabled="!bulkUpdateReady"
                        :action="saveBulkPrices"
                        :loading="bulkUpdating"></v-executer>
                </template>
            </b-modal>
            <div class="table-responsive">
                <table class="table table-hover table-sm align-middle">
                    <thead>
                        <tr>
                            <th class="w-20 text-nowrap">Kod</th>
                            <th class="w-20 text-nowrap">Cari</th>
                            <th class="w-20 text-nowrap">Sözleşme Kodu</th>
                            <th class="w-20 text-nowrap">Sözleşme Adı</th>
                            <th class="w-20 text-nowrap">Sözleşme Baş. Tarihi</th>
                            <th class="w-20 text-nowrap">Sözleşme Bit. Tarihi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-nowrap">{{ Agreement.CariCode || '-' }}</td>
                            <!-- Cari yalnızca boşken bağlanabilir. Dolu bir cariyi değiştirmek bu
                                 sözleşmenin geçmiş sefer fiyatlamalarını başka firmaya kaydırır;
                                 sunucu da bu durumda isteği reddeder. -->
                            <td class="text-nowrap">
                                <div class="d-flex align-items-center">
                                    <span>{{ Agreement.CariName || '-' }}</span>
                                    <button v-if="!Agreement.CariCode" v-on:click="startCariEdit" title="Cari seç" class="btn btn-xxs btn-icon btn-flat-warning ml-25">
                                        <feather-icon icon="EditIcon"/>
                                    </button>
                                </div>
                                <small v-if="!Agreement.CariCode" class="text-danger d-block">
                                    Cari tanımlı değil; bu sözleşmenin fiyatları seferlere uygulanmaz.
                                </small>
                            </td>
                            <td class="text-nowrap">{{Agreement.AgreementCode}}</td>
                            <td class="text-nowrap">{{ Agreement.Name }}</td>
                            <td class="text-nowrap">{{Agreement.StartDate}}</td>
                            <td class="text-nowrap">
                                <div v-if="isEditingExpireDate" class="d-flex align-items-start">
                                    <div style="min-width: 170px;">
                                        <v-date-picker v-model="Agreement.ExpireDateValue" placeholder="Sözleşme Bitiş Tarihi"></v-date-picker>
                                        <small v-if="expireDateValidationMessage" class="text-danger d-block mt-25">{{ expireDateValidationMessage }}</small>
                                    </div>
                                    <button v-on:click="updateExpireDate" :disabled="!canUpdateExpireDate || expireDateUpdating" class="btn btn-xxs btn-icon btn-flat-primary ml-25 mt-25">
                                        <div v-if="expireDateUpdating" class="spinner-border spinner-border-sm"></div>
                                        <feather-icon v-else icon="SaveIcon"/>
                                    </button>
                                    <button v-on:click="cancelExpireDateEdit" :disabled="expireDateUpdating" class="btn btn-xxs btn-icon btn-flat-secondary ml-25 mt-25">
                                        <feather-icon icon="XIcon"/>
                                    </button>
                                </div>
                                <div v-else class="d-flex align-items-center">
                                    <span>{{ Agreement.ExpireDate }}</span>
                                    <button v-on:click="startExpireDateEdit" class="btn btn-xxs btn-icon btn-flat-warning ml-25">
                                        <feather-icon icon="EditIcon"/>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <!-- <div class="row table-responsive">
                <table class="table table-bordered w-100 table-sm align-middle mt-2">
                    <thead>
                        <tr>
                            <th class="w-25 text-nowrap">Fiyata Enflasyon Etki Oranı</th>
                            <th class="w-25 text-nowrap">Enflasyon Oranı</th>
                            <th class="w-25 text-nowrap">Fiyata Yakıt Etki Oranı</th>
                            <th class="w-25 text-nowrap">Yakıt Fiyatı Artış/Azalış</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-nowrap">%{{ Agreement.AgreementPriceFactor.InflationAffectValue }}</td>
                            <td class="text-nowrap">%{{Agreement.AgreementPriceFactor.InflationAffectRateValue}}</td>
                            <td class="text-nowrap">%{{ Agreement.AgreementPriceFactor.FuelAffectValue}}</td>
                            <td class="text-nowrap">%{{Agreement.AgreementPriceFactor.FuelAffectRateValue}}</td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
            <div class="row">
                <div class="col-md-3 mb-1 mb-md-0">
                    <v-stats-box body-class="px-75 p-50" text="Fiyata Enflasyon Etki Oranı" variant="primary" icon="percent" :value="Agreement.AgreementPriceFactor.InflationAffectValue" ></v-stats-box>
                </div>
                <div class="col-md-3 mb-1 mb-md-0">
                    <v-stats-box body-class="px-75 p-50" text="Enflasyon Oranı" variant="primary" icon="percent" :value="Agreement.AgreementPriceFactor.InflationAffectRateValue" ></v-stats-box>
                </div>
                <div class="col-md-3 mb-1 mb-md-0">
                    <v-stats-box body-class="px-75 p-50" text="Fiyata Yakıt Etki Oranı" variant="primary" icon="percent" :value="Agreement.AgreementPriceFactor.FuelAffectValue" ></v-stats-box>
                </div>
                <div class="col-md-3 mb-1 mb-md-0">
                    <v-stats-box body-class="px-75 p-50" text="Yakıt Fiyatı Artış/Azalış" variant="primary" icon="percent" :value="Agreement.AgreementPriceFactor.FuelAffectRateValue" ></v-stats-box>
                </div>
            </div>
            <hr>
            <div class="row justify-content-between align-items-end">
                <div class="col-md-3 mb-1">
                    <v-stats-box  text="Bugünün Yakıt Fiyatı" variant="warning" icon="oil_barrel" :value="Agreement.CurrentFuelPrice" ></v-stats-box>
                </div>
            </div>
            <hr>
            <!-- Belge yükleme/güncelleme, indirme ve sürüm geçmişi tek bileşende. -->
            <agreement-document-card :agreement="Agreement" v-on:updated="getDetail"></agreement-document-card>
            <hr>
            <div class="row justify-content-end">
                <div class="col-md-auto mb-1 mb-md-0">
                    <button class="btn btn-success text-nowrap" v-on:click="inflationUpdateModal">
                        <feather-icon icon="ActivityIcon" class="mr-50" size="14" ></feather-icon>
                        Enflasyon Oranı Güncelle
                    </button>
                </div>
            </div>
        </b-card>
        <b-card>
            <div class="row justify-content-between align-items-center">
                <div class="col mx-50">
                    <h2 class="mb-0">Rota Fiyatları</h2>
                </div>
                <div class="col-auto">
                    <div class="row">
                        <div class="col-auto">
                            <v-executer variant="success" :action="downloadRoutes" :loading="routesDownloading">
                                <div class="d-flex align-items-center">
                                    <feather-icon size="14" class="mr-50" icon="FileIcon"/>
                                    Excel
                                </div>
                            </v-executer> 
                        </div>
                        <div class="col-auto" v-if="selectedRouteIds.length">
                            <button class="btn btn-danger" v-on:click="showBulkDeleteRoutes">
                                <feather-icon icon="TrashIcon" size="14" class="mr-25"></feather-icon>
                                Seçilenleri Sil ({{ selectedRouteIds.length }})
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-outline-secondary" v-on:click="showBulkAddRoutes">
                                <feather-icon icon="UploadIcon" size="14" class="mr-25"></feather-icon>
                                Excel ile Toplu Rota
                            </button>
                        </div>
                        <div class="col-auto">
                            <button
                                class="btn btn-outline-secondary"
                                :disabled="(Agreement.AgreementRoutePrices || []).length === 0"
                                v-on:click="showBulkUpdatePrices">
                                <feather-icon icon="Edit3Icon" size="14" class="mr-25"></feather-icon>
                                Toplu Fiyat Düzenle
                            </button>
                        </div>
                        <div class="col-auto ">
                            <button class="btn btn-secondary" v-on:click="showAddRoute">Yeni Rota</button>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-1 table-responsive mb-0" >
                    <table class="table table-bordered table-sm align-middle mb-0">
                        <thead>
                            <tr>
                                <th class="text-nowrap text-center px-50">
                                    <input type="checkbox" :checked="allRoutesSelected" v-on:change="toggleAllRoutes" />
                                </th>
                                <th class="text-nowrap">Sıra</th>
                                <th class="text-nowrap">Başlangıç Bölgesi</th>
                                <th class="text-nowrap">Bitiş Bölgesi</th>
                                <th class="text-nowrap">Araç Tipi</th>
                                <th class="text-nowrap">Ürün Tipi</th>
                                <th class="text-nowrap">Taşıma Tipi</th>
                                <th class="text-nowrap">Fiyat</th>
                                <th class="text-nowrap">Son Güncelleme Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(data,i) in Agreement.AgreementRoutePrices">
                                <tr :key="data.Id">
                                    <td class="text-nowrap text-center p-0">
                                        <input type="checkbox" :value="data.Id" v-model="selectedRouteIds" />
                                    </td>
                                    <td class="text-nowrap text-center font-weight-bolder p-0">{{ i+1 }}</td>
                                    <td class="text-nowrap">{{ data.StartRegionName }}</td>
                                    <td class="text-nowrap">{{ data.EndRegionName }}</td>
                                    <td class="text-nowrap">{{ data.VehicleTypeName }}</td>
                                    <td class="text-nowrap">{{ data.StockName }}</td>
                                    <td class="text-nowrap">{{ data.StatusStr }}</td>
                                    <td class="text-nowrap text-right">
                                        <div class="d-flex align-items-center justify-content-end">
                                            <b-badge class="primary">{{ data.PriceStr +'₺'}} </b-badge>
                                            <button v-on:click="showUpdatePrice(data)" class="btn btn-xxs btn-icon btn-flat-warning ml-25"><feather-icon icon="EditIcon"/></button>
                                            <button v-on:click="deleteRoutePrice(data)" class="btn btn-xxs btn-icon btn-flat-danger ml-25"><feather-icon icon="TrashIcon"/></button>
                                        </div>
                                    </td>
                                    <td class="text-nowrap">{{ data.StartDate }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BBadge, BCard,BFormCheckbox,BAlert,BFormRadio,BFormRadioGroup } from 'bootstrap-vue'
import { AgreementApi } from '@/api/agreement'
import UpdateInflation from './components/UpdateInflation.vue'
import VStatsBox from '@/components/VStatsBox.vue'
import Additional from '@/utilities/additional'
import AgreementDocumentCard from '@/components/AgreementDocumentCard.vue'
import Auth from '@/utilities/auth'
import AddRoute from './components/AddRoute.vue'
import BulkAddRoutes from './components/BulkAddRoutes.vue'
import BulkUpdatePrices from './components/BulkUpdatePrices.vue'
import UpdateRoutePrice from './components/UpdateRoutePrice.vue'
import { NetsisApi } from '@/api/netsis'
import moment from 'moment'

export default {
    components:{
        AgreementDocumentCard,
        BCard,
        BBadge,
        VStatsBox,
        BFormCheckbox,
        BAlert,
        BFormRadio,
        BFormRadioGroup,
        UpdateInflation,
        AddRoute,
        BulkAddRoutes,
        BulkUpdatePrices,
        UpdateRoutePrice
    },
    data(){
        return{
            detailLoading: false,
            InflationData:{
                Inflation:null
            },
            isEditingExpireDate:false,
            expireDateUpdating:false,
            cariList:[],
            cariLoading:false,
            cariUpdating:false,
            // Cari bağlama sırasında seçilen değer. Agreement.CariCode sunucudan gelen kayıtlı
            // değeri temsil ettiği için seçim ayrı tutulur.
            CariSelection:{
                CariCode:null,
                CariName:null
            },
            Agreement:{
                Id:null,
                FirmCariCode:null,
                AgreementCode:null,
                CariName:null,
                CariCode:null,
                CreateTime:null,
                AgreementDocumentUrl:null,
                AgreementDocumentName:null,
                AgreementDocumentVersion:null,
                AgreementDocumentUploadedAt:null,
                AgreementDocumentUploadedByUserName:null,
                AgreementDocumentVersionCount:0,
                Name:null,
                FirmId:null,
                CurrentFuelPrice:null,
                StartDate:null,
                StartDateValue:null,
                ExpireDate:null,
                ExpireDateValue:null,
                OriginalExpireDateValue:null,
                AgreementRoutePrices:[],
                AgreementPriceFactor:{
                    FuelAffectRateValue:null,
                    FuelAffectRateValueActive:null,
                    FuelAffectValue:null,
                    FuelAffectValueActive:null,
                    InflationAffectValue:null,
                    InflationAffectValueActive:null,
                    InflationAffectRateValueActive:null,
                    InflationAffectRateValue:null
                },
            },
            routeAdding:false,
            routeValidationMessage:null,
            bulkAdding:false,
            bulkUpdating:false,
            // Alt bileşenler kaydedilebilir olup olmadıklarını yukarı bildirir; $refs üzerinden
            // okumak tepkisel olmadığı için düğme durumu güncellenmezdi.
            bulkAddReady:false,
            bulkUpdateReady:false,
            selectedRouteIds:[],
            bulkDeleting:false,
            // Varsayılan tüm geçmişiyle silme: rotalar yeniden eklenecekse temiz zemin gerekir.
            deleteIncludeHistory:true,
            route:{
                AgreementId:null,
                Status:null,
                StartRegionId:null,
                EndRegionId:null,
                StockCode:null,
                StockName:null,
                VehicleTypeId:null,
                // Rota baz tarihi yalnızca rota seviyesinde tutulur; sözleşme ekranındaki
                // rota tablosunda gösterilmez.
                FuelBaseDate:null,
                RoutePrices:[
                    {Price:null,StartDate:null}
                ]
            },
            currentRoutePrice:null,
            priceUpdating:false,
            routesDownloading:false
        }
    },
    mounted(){
        this.getDetail()
    },
    methods:{
        isInRole(roles){
            let x = Auth.hasRole([roles])
            return x
        },
        downloadRoutes(){
            const id = this.$route.params.id
            this.routesDownloading = true
            AgreementApi.DownloadRoutes(id).then(res => {
                Additional.DownloadFile(res.data, [this.Agreement.CariCode,this.Agreement.AgreementCode,this.Agreement.Name,'Rota Fiyatlar'].join(' - ').concat('.xlsx'))
                this.routesDownloading = false
            })
        },
        getDetail(){
            this.detailLoading = true
            const id = this.$route.params.id
            AgreementApi.Detail(id).then(res => {
                this.Agreement.Id = res.data.Data.Id
                this.Agreement.CreateTime = res.data.Data.CreateTime
                this.Agreement.FirmCariCode = res.data.Data.FirmCariCode
                this.Agreement.AgreementCode = res.data.Data.AgreementCode
                this.Agreement.CariName = res.data.Data.CariName
                this.Agreement.CariCode = res.data.Data.CariCode
                this.Agreement.Name = res.data.Data.Name
                this.Agreement.AgreementRoutePrices = res.data.Data.AgreementRoutePrices
                this.Agreement.AgreementDocumentUrl = res.data.Data.AgreementDocumentUrl
                this.Agreement.AgreementDocumentName = res.data.Data.AgreementDocumentName
                this.Agreement.AgreementDocumentVersion = res.data.Data.AgreementDocumentVersion
                this.Agreement.AgreementDocumentUploadedAt = res.data.Data.AgreementDocumentUploadedAt
                this.Agreement.AgreementDocumentUploadedByUserName = res.data.Data.AgreementDocumentUploadedByUserName
                this.Agreement.AgreementDocumentVersionCount = res.data.Data.AgreementDocumentVersionCount
                this.Agreement.CurrentFuelPrice = res.data.Data.CurrentFuelPrice
                this.Agreement.ExpireDate = res.data.Data.ExpireDate
                this.Agreement.StartDate = res.data.Data.StartDate
                this.Agreement.StartDateValue = this.normalizeDateValue(res.data.Data.StartDate)
                this.Agreement.ExpireDateValue = this.normalizeDateValue(res.data.Data.ExpireDate)
                this.Agreement.OriginalExpireDateValue = this.Agreement.ExpireDateValue
                this.isEditingExpireDate = false
                this.Agreement.AgreementPriceFactor.FuelAffectRateValue = res.data.Data.AgreementPriceFactor.FuelAffectRateValue
                this.Agreement.AgreementPriceFactor.FuelAffectRateValueActive = res.data.Data.AgreementPriceFactor.FuelAffectRateValueActive
                this.Agreement.AgreementPriceFactor.FuelAffectValueActive = res.data.Data.AgreementPriceFactor.FuelAffectValueActive
                this.Agreement.AgreementPriceFactor.FuelAffectValue = res.data.Data.AgreementPriceFactor.FuelAffectValue
                this.Agreement.AgreementPriceFactor.InflationAffectValue = res.data.Data.AgreementPriceFactor.InflationAffectValue
                this.Agreement.AgreementPriceFactor.InflationAffectValueActive = res.data.Data.AgreementPriceFactor.InflationAffectValueActive
                this.Agreement.AgreementPriceFactor.InflationAffectRateValueActive = res.data.Data.AgreementPriceFactor.InflationAffectRateValueActive
                this.Agreement.AgreementPriceFactor.InflationAffectRateValue = res.data.Data.AgreementPriceFactor.InflationAffectRateValue
            }).catch(err => {
                console.error(err);
            }).finally(() => { this.detailLoading = false })
        },
        normalizeDateValue(value){
            if(!value){
                return null
            }

            const parsedDate = moment(value,'DD.MM.YYYY',true)
            return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : value
        },
        getCariList(data){
            if(data){
                this.cariLoading = true
                NetsisApi.CariList(data).then(res => {
                    this.cariList = res.data.Data
                    this.cariLoading = false
                }).catch(err=> {
                    console.error(err)
                    this.cariLoading = false
                })
            }
        },
        startCariEdit(){
            this.CariSelection.CariCode = null
            this.CariSelection.CariName = null
            this.cariList = []
            this.$showModal('update-cari')
        },
        updateCari(){
            if(!this.canUpdateCari){
                return
            }

            this.cariUpdating = true
            AgreementApi.UpdateCari({
                AgreementId:this.Agreement.Id,
                CariCode:this.CariSelection.CariCode,
                CariName:this.CariSelection.CariName
            }).then(res => {
                if(res.data.Success){
                    this.CariSelection.CariCode = null
                    this.CariSelection.CariName = null
                    this.$hideModal('update-cari')
                    this.getDetail()
                }
                this.$result(res)
                this.cariUpdating = false
            }).catch(err => {
                this.$result(null,err)
                this.cariUpdating = false
            })
        },
        startExpireDateEdit(){
            this.Agreement.ExpireDateValue = this.Agreement.OriginalExpireDateValue
            this.isEditingExpireDate = true
        },
        cancelExpireDateEdit(){
            this.Agreement.ExpireDateValue = this.Agreement.OriginalExpireDateValue
            this.isEditingExpireDate = false
        },
        updateExpireDate(){
            if(!this.canUpdateExpireDate){
                return
            }

            this.expireDateUpdating = true
            AgreementApi.UpdateExpireDate({
                AgreementId:this.Agreement.Id,
                ExpireDate:this.Agreement.ExpireDateValue
            }).then(res => {
                if(res.data.Success){
                    this.getDetail()
                }
                this.$result(res)
                this.expireDateUpdating = false
            }).catch(err => {
                this.$result(null,err)
                this.expireDateUpdating = false
            })
        },
        inflationUpdateModal(){
            this.$showModal('update-inflation')
        },
        updateInflation(){
            AgreementApi.UpdateInflationRate({
                InflationRate: this.InflationData.Inflation,
                AgreementId:this.$route.params.id
            }).then(res => {
                this.$hideModal('update-inflation')
                this.getDetail()
                this.InflationData.Inflation = 0
                this.$result(res)
            })
        },
        provider(data){
            return AgreementApi.Table(data)
        },
        createNew(){
            this.$router.push({name:'agreement-create'})
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FirmName} firmasıyla olan ${item.Name} adlı sözleşmeyi silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    AgreementApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                        
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        toggleAllRoutes(event){
            this.selectedRouteIds = event.target.checked
                ? (this.Agreement.AgreementRoutePrices || []).map(r => r.Id)
                : []
        },
        showBulkDeleteRoutes(){
            this.deleteIncludeHistory = true
            this.$showModal('bulk-delete-routes')
        },
        deleteSelectedRoutes(){
            this.bulkDeleting = true
            return AgreementApi.DeleteRoutes({
                AgreementId: this.$route.params.id,
                RoutePriceIds: this.selectedRouteIds,
                IncludeHistory: this.deleteIncludeHistory
            }).then(res=>{
                this.bulkDeleting = false
                if(res.data.Success){
                    this.selectedRouteIds = []
                    this.getDetail()
                    this.$hideModal('bulk-delete-routes')
                }
                this.$result(res)
            }).catch(err=>{
                this.bulkDeleting = false
                this.$result(null,err)
            })
        },
        showBulkAddRoutes(){
            this.bulkAddReady = false
            if(this.$refs.bulkAddRoutes)
                this.$refs.bulkAddRoutes.reset()
            this.$showModal('bulk-add-routes')
        },
        saveBulkRoutes(){
            this.bulkAdding = true
            return this.$refs.bulkAddRoutes.save().then(res=>{
                this.bulkAdding = false
                if(res.data.Success){
                    this.getDetail()
                    this.$hideModal('bulk-add-routes')
                    this.$result(res)
                }
                // Hata durumunda modal açık kalır: satır bazlı hatalar bileşende listeleniyor.
            }).catch(err=>{
                this.bulkAdding = false
                this.$result(null,err)
            })
        },
        showBulkUpdatePrices(){
            this.bulkUpdateReady = false
            if(this.$refs.bulkUpdatePrices)
                this.$refs.bulkUpdatePrices.buildRows()
            this.$showModal('bulk-update-prices')
        },
        saveBulkPrices(){
            this.bulkUpdating = true
            return this.$refs.bulkUpdatePrices.save().then(res=>{
                this.bulkUpdating = false
                if(res.data.Success){
                    this.getDetail()
                    this.$hideModal('bulk-update-prices')
                    this.$result(res)
                }
            }).catch(err=>{
                this.bulkUpdating = false
                this.$result(null,err)
            })
        },
        showAddRoute(){
            this.route.AgreementId = this.$route.params.id
            this.route.Status = null
            this.route.StartRegionId = null
            this.route.EndRegionId = null
            this.route.StockCode = null
            this.route.StockName = null
            this.route.VehicleTypeId = null
            this.route.FuelBaseDate = null
            this.route.RoutePrices = [{Price:null,StartDate:null}]
            this.$showModal('add-route')
        },
        addRoute(){
            this.routeAdding = true
            AgreementApi.AddRoute(this.route).then(res=>{
                this.routeAdding = false
                if(res.data.Success) {
                    this.getDetail()
                    this.$hideModal('add-route')
                }
                this.$result(res)
                
            }).catch(err=>{
                this.routeAdding = false
                this.$result(null,err)
            })
        },
        deleteRoutePrice(rp){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem sözleşme rotasını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    AgreementApi.DeleteRoute(rp.Id).then(res=>{
                        if(res.data.Success) {
                            this.getDetail()
                        }
                        this.$result(res)   
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        showUpdatePrice(rp){
            this.currentRoutePrice = null
            this.currentRoutePrice = {
                ...rp,
                NewPrice:rp.Price,
                // Varsayılan "düzeltme": aksi belirtilmedikçe mazot baz'ına dokunulmaz.
                ChangeKind:'correction',
                FuelBaseDate:null,
                ChangeNote:null
            }
            this.$showModal('update-price')
        },
        updatePrice(){
            this.priceUpdating=true
            AgreementApi.UpdateRoutePrice({
                Id: this.currentRoutePrice.Id,
                Price: this.currentRoutePrice.NewPrice,
                // Boş gönderilmesi "düzeltme" demektir: sunucu mazot baz'ını korur.
                FuelBaseDate: this.currentRoutePrice.FuelBaseDate || null,
                ChangeNote: this.currentRoutePrice.ChangeNote || null
            }).then(res => {
                if(res.data.Success){
                    this.$hideModal('update-price')
                    this.getDetail()
                }
                this.$result(res)
                this.priceUpdating=false
            }).catch(err => {
                this.$result(null,err)
                this.priceUpdating=false
            })
        }
    },
    computed:{
        allRoutesSelected(){
            const rows = this.Agreement.AgreementRoutePrices || []
            return rows.length > 0 && this.selectedRouteIds.length === rows.length
        },
        canUpdatePrice(){
            const rp = this.currentRoutePrice
            if(rp == null) return false
            if(rp.NewPrice == null || rp.NewPrice <= 0) return false
            // Yeni pazarlık seçildiyse baz tarih zorunlu; düzeltmede gönderilmez.
            if(rp.ChangeKind === 'renegotiation' && !rp.FuelBaseDate) return false
            // Fiyat aynı kalsa bile yeni pazarlık anlamlıdır: mazot baz'ı taşınır, birikmiş
            // zamlardan feragat edilir. Düzeltmede ise fiyat değişmediyse yapılacak iş yok.
            if(rp.Price == rp.NewPrice && rp.ChangeKind !== 'renegotiation') return false
            return true
        },
        cari:{
            get:function(){
                return this.cariList.find(s=>s.CARI_KOD==this.CariSelection.CariCode)
            },
            set:function(value){
                this.CariSelection.CariCode = value?.CARI_KOD || null
                this.CariSelection.CariName = value?.CARI_ISIM || null
            }
        },
        canUpdateCari(){
            return !!this.CariSelection.CariCode && !!this.CariSelection.CariName
        },
        expireDateChanged(){
            return this.Agreement.ExpireDateValue != null && this.Agreement.ExpireDateValue !== this.Agreement.OriginalExpireDateValue
        },
        expireDateValidationMessage(){
            if(!this.Agreement.ExpireDateValue){
                return 'Sözleşme bitiş tarihi seçilmelidir.'
            }

            if(this.Agreement.StartDateValue != null && this.Agreement.ExpireDateValue <= this.Agreement.StartDateValue){
                return 'Sözleşme bitiş tarihi başlangıç tarihinden büyük olmalıdır.'
            }

            return null
        },
        canUpdateExpireDate(){
            return this.expireDateChanged && this.expireDateValidationMessage == null
        },
        hasEmpty(){
            // Rota baz tarihi zorunlu: fiyatın hangi mazot seviyesinde verildiği bilinmeden
            // rota kaydedilemez.
            return this.route.FuelBaseDate == null
                || this.routeValidationMessage != null
                || this.route.RoutePrices.some(r => r.Price == null || r.StartDate == null)
        }
    }
}
</script>
